/**
 * Native select with label for dark-themed forms (glass surface, sky focus).
 */
const controlSurface =
  "w-full min-h-[2.75rem] appearance-none rounded-xl border border-white/10 bg-white/[0.04] px-4 py-2.5 pr-10 text-sm text-white shadow-sm backdrop-blur-sm transition-all duration-200 " +
  "hover:border-white/20 " +
  "focus:border-sky-400/55 focus:outline-none focus:ring-2 focus:ring-sky-400/50 focus:ring-offset-2 focus:ring-offset-black/40 " +
  "disabled:cursor-not-allowed disabled:opacity-50 [color-scheme:dark]";

export default function SelectField({
  id,
  label,
  value,
  onChange,
  options,
  required = false,
  disabled = false,
  showPlaceholder = true,
  placeholderLabel = "Select…",
  hideLabel = false,
  className = "",
}) {
  const selectId = id || (label ? label.toLowerCase().replace(/\s+/g, "-") : "select");

  return (
    <div className={className}>
      {!hideLabel ? (
        <label htmlFor={selectId} className="block text-sm font-medium text-white/90">
          {label}
          {required ? <span className="text-rose-300"> *</span> : null}
        </label>
      ) : null}
      <div className={hideLabel ? "relative" : "relative mt-1"}>
        <select
          id={selectId}
          name={selectId}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          className={controlSurface}
          aria-label={hideLabel ? label : undefined}
        >
          {showPlaceholder ? (
            <option value="" disabled>
              {placeholderLabel}
            </option>
          ) : null}
          {options.map((opt) => (
            <option
              key={String(opt.value)}
              value={opt.value}
              disabled={Boolean(opt.disabled)}
              className="bg-neutral-900"
            >
              {opt.label}
            </option>
          ))}
        </select>
        <span
          className="pointer-events-none absolute inset-y-0 right-0 flex w-10 items-center justify-center text-white/45"
          aria-hidden
        >
          <svg className="h-4 w-4 shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </div>
    </div>
  );
}
